import { z } from 'zod';

export const editStaffFormSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.email('Invalid email address'),
  phoneNumber: z
    .string()
    .min(1, 'Phone number is required')
    .regex(/^\+250\d{9}$/, 'Phone number must be in format +250 7XX XXX XXX'),
  role: z.string().min(1, 'Role is required'),
  trackingLevel: z.string().min(1, 'Tracking level is required'),
  assignedLocations: z.array(z.string()).optional(),
});

export type NewStaffFormSchema = z.infer<
  typeof editStaffFormSchema
>;
